/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {EnvironmentModule} from "@modules/EnvironmentModule";
import {FONTS} from "@res/fonts";

export class LogoutButton
	extends React.Component {

	render() {
		return <div
			className={`ll_h_c clickable`}
			onClick={EnvironmentModule.logout}>
			{FONTS.reg_11_secondary_dark('Logout')}
		</div>;
	}
}
